import { Component } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'weaccess-alert-modal',
  templateUrl: './details-success-modal.component.html',
  styleUrls: ['./details-success-modal.component.scss']
})
export class DetailsSuccessModal {
  accessData: any;
  successModel: boolean = true;
  initialState: any;

  constructor(private bsModalRef: BsModalRef,
    private modalService: BsModalService,
  ) {
    this.initialState = this.modalService.config.initialState;
    this.accessData = this.initialState.data.data;
  }

  /** Close button click event functionality */
  onClose() {
    this.bsModalRef.hide();
  }
}
